import { memo, useContext} from 'react'
import PropsContext from 'context/props'
import styled from 'styled-components'
import { useIntl } from 'react-intl'
import { getRGBA } from 'utils/analysis'   
import { getQuestionParsing } from 'utils/survey'
import Question from 'styled/Custom/Question'
import htmlParser from 'react-html-parser'

export const getScrollStyle = (max_height, font_family, bg_color) => {
    // 높이값이 있구 잘난체, 본고딕일경우 padding-bottom: 2px를 줘야 max-height를 안넘을때 스크롤이 안생긴다
    const is_pb = Boolean(max_height && (font_family === 'yg-jalnan' || font_family === 'Noto Sans KR'))

    return (
        `
        padding: ${is_pb ? '0 5px 2px 0' : max_height ? '0 5px 0 0' : 0};
        max-height: ${max_height ? `${ max_height}px` : 'auto'};
        overflow-y: ${max_height ? 'auto' : 'hidden'};
        
        &::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }
    
        &::-webkit-scrollbar-track {
            background: transparent;
        }
    
        &::-webkit-scrollbar-thumb {
            background-color: ${getRGBA({color: bg_color, opacity: .3})};
            border-radius: 10px;
        }
        `
    )
} 


const WrapperStyled = styled.div`
    font-size: 1.3rem;
    word-break: break-all;
    position: relative;
`
const HasNotNumberStyled = styled.div`
    width: 100%;
    ${({ max_height, font_family, bg_color }) => getScrollStyle(max_height, font_family, bg_color)};
`

function QuestionComponent(props) {
    const { question, max_height } = props
    const { design } = useContext(PropsContext)

    const { question: color, font_family } = design

    const { formatMessage: f } = useIntl()

    return (
        <WrapperStyled>
            <HasNotNumberStyled max_height={max_height} font_family={font_family} bg_color={color}>
                <Question>{getQuestionParsing(question) || htmlParser(f({id: 'component.Survey.Modules.Common.Subject.question'}))}</Question>
            </HasNotNumberStyled>
        </WrapperStyled> 
    )
}

export default memo(QuestionComponent)